import { Injectable } from '@angular/core';
import { fromEvent, map, Observable } from 'rxjs';

const TABLET_BREAKPOINT = 1150;
const MOBILE_BREAKPOINT = 767;

export enum EDevices {
  desktop = 'desktop',
  tablet = 'tablet',
  mobile = 'mobile',
}

@Injectable({
  providedIn: 'root'
})

export class ResponsiveService {
  public device$: Observable<EDevices>;

  constructor() {
    this.device$ = fromEvent(window, 'resize').pipe(
      map(() => this.getDevice())
    );
  }

  public getDevice(): EDevices {
    if (window.innerWidth <= MOBILE_BREAKPOINT) {
      return EDevices.mobile;
    } else if (window.innerWidth <= TABLET_BREAKPOINT) {
      return EDevices.tablet;
    }

    return EDevices.desktop;
  }
}
